/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { clFarmAbi } from "@/domains/abis"
import { simulatedTransaction } from "../simulated-transaction"

type StakeClFarmLiquidityProps = {
  account: Address
  chainId: number
  config: Config
  farmAddress: Address
  amount: bigint
}

export const stakeClFarmLiquidity = async ({
  account,
  chainId,
  config,
  farmAddress,
  amount,
}: StakeClFarmLiquidityProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: clFarmAbi as Abi,
        account,
        address: farmAddress,
        args: [amount],
        chainId,
        functionName: "deposit",
      },
    })
    return result
  } catch (error: any) {
    console.error("stakeClFarmLiquidity", error)
    return { success: false, error: error.message, code: error.code }
  }
}
